import DTransfer from './src';

DTransfer.install = Vue => {
  Vue.component('DTransfer', DTransfer);
};

export default DTransfer;
